
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';
import CategoriesScreen from './categories';
import ListProducts from './ListProducts';

function Index({dishs2, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [dataFood, setDataFood] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false); 
    const [grill, setGrill] = useState(false);
    const [ribeye, setRibeye] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showCocteles, setshowCocteles] = useState(false);
    const [showListProduct, setShowListProduct2] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);
    

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 257) {
                setDataFood(item.menus);
            }
            if(item.id === 851) {
                    setshowCocteles(item);
                }
        });
    }, [menus]);

    useEffect(() => {
        if (dataFood) {
            dataFood.map((item) => {
                if (item.id === 2811) {
                    setGrill(item);
                }
                if (item.id === 2385) {
                    setRibeye(item);
                }
            });
        }
    }, [dataFood]);
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 8000}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct} goHome={setShowHappy}
                goCategories={() => {
             
                setShowListProduct2(true)
                setdishs(showCocteles)
            }}
            >
                <div  style={{padding: '0 20px'}}>
                    <div
                        onClick={() => {
                            //setShowDetailProduct(true);
//                            setDataDish({ dish: grill, alldish: dataFood, currentDish: grill })
                        }}>
                        
                        <img
                            src={require('./assets/lunchspecials.png')}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                height: 90,
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />


                        <img
                            src={require('./assets/specials.png')}
                            style={{
                                width: '100%',
                                height: 700,
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
                       
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                   {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

                {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct2}
            />}
            </LayoutContent>
        </div>
    );
}
export default Index;